import { useEffect, useMemo, useState } from 'react';

import { CODE_LENGTH } from 'utils/constants';

import { FieldData } from 'models';

export const useCodeForm = () => {
	const [fields, setFields] = useState<FieldData[]>([]);
	const [disabled, setDisabled] = useState(false);
	const [isValid, setIsValid] = useState(false);

	const code: FieldData | any = useMemo(
		() =>
			fields.find((item) => {
				const name = item.name as string;
				return name.includes('code');
			}) || {},
		[fields],
	);

	useEffect(() => {
		const isValid = code?.value?.length === CODE_LENGTH && !disabled && code.errors?.length === 0;

		setIsValid(isValid);
	}, [code, disabled]);

	return {
		fields,
		disabled,
		setFields,
		setIsValid,
		isValid,
		setDisabled,
		code,
	};
};
